export default {
    notdone: {
        headers: {
            date: 'Дата',
            name: 'Событие',
            projects: 'Проект',
            people: 'Человек',
            contact: 'Контактное лицо',
            organizations: 'Компания',
            time: 'Время',
            comment: 'Комментарий',
            responsible: 'Сотрудник',
        }
    }
};
